import {
  _throttle,
  _debounce,
  handleFindLayoutComponentOptions,
  getDefaultColsUidInLayoutComponent,
  formatterDateHandle,
  replaceUrlParam,
  findTabs,
  getSwData,
  getRectAttribute,
  handleFindLayoutComponentAllUid,
  handleFindLayoutComponentOptionsCols,
  findHistoryLayoutType,
  isFieldAllEmpty,
  isBigScreenPreview,
  simpleDeepClone,
  parseQueryString,
  getQueryParam
} from "utils/index"
import { fixComponent, isImage } from "utils/analysisTypeId.js"
import { CATEGORY_MODE } from "@/consts"

export class UpdateLayoutData {
  constructor(vue) {
    this.context = vue
  }
  //upDateRect：开始生成自由布局组件前的检查
  async upDateRect({
    activeIndex,
    pageNum,
    typeId,
    pageSize,
    totalRecords,
    rectAttr,
    cacheDataTypes,
    restDataUrl,
    ids,
    typeIds,
    relIds,
    isOr,
    dateVal,
    addCb,
    updateCb,
    hideComponentCb,
    componentBoxUpdateCb,
    delElementCb,
    updateEleCb,
    showComponentCb,
    componentBoxUpdateOpacity,
    wholeDataTypes,
    dataCenterContent
  }) {
    this.rectAttr = rectAttr
    this.cacheDataTypes = cacheDataTypes
    this.restDataUrl = restDataUrl
    this.activeIndex = activeIndex
    this.pageNum = pageNum ? pageNum : 1
    this.typeId = typeId
    this.pageSize = pageSize
    this.totalRecords = totalRecords
    this.ids = ids
    this.typeIds = typeIds
    this.relIds = relIds
    this.isOr = isOr
    this.dateVal = dateVal
    this.addCb = addCb
    this.updateCb = updateCb
    this.hideComponentCb = hideComponentCb
    this.showComponentCb = showComponentCb
    this.componentBoxUpdateCb = componentBoxUpdateCb
    this.delElementCb = delElementCb
    this.updateEleCb = updateEleCb
    this.componentBoxUpdateOpacity = componentBoxUpdateOpacity
    this.wholeDataTypes = wholeDataTypes ?? []
    this.dataCenterContent = dataCenterContent
    return {
      ...(await this.getAllUidInLayoutComponent()),
      colsIdFromActiveRect: this.colsIdFromActiveRect,
      totalRecords: this.totalRecords,
      pageSize: this.pageSize
      // breadCrumbsData: this.breadCrumbsData
    }
  }
  //递归查找布局组件中所有的可使用的col
  async getAllUidInLayoutComponent() {
    const colsIdFromActiveRect = this.getColsIdFromActiveRect()
    this.colsIdFromActiveRect = colsIdFromActiveRect
    let sizeStr = colsIdFromActiveRect.length
    // 判断当前自由布局中是否包含有插件的表格组件
    let isContainPluginTable = this.isContainPluginTable(colsIdFromActiveRect)
    // 滚动自由布局才可以
    const oldRowsLength = this.rectAttr.options.oldRowsLength
    const oldColsLength = this.rectAttr.options.oldColsLength
    const turnOnScroll = this.rectAttr.options.turnOnScroll
    if (turnOnScroll || isContainPluginTable) {
      sizeStr = 50
    } else if (turnOnScroll === false && oldRowsLength && oldColsLength === 1) {
      sizeStr = oldRowsLength
    } else if (turnOnScroll === false && oldColsLength && oldRowsLength === 1) {
      sizeStr = oldColsLength
    }
    this.pageSize = sizeStr
    const result = await this.getAppointData(this.pageSize)
    let backData = result?.data?.data?.datas?.datas
    this.totalRecords = result?.data?.data?.datas?.totalRecords
    // 解决 表单接口不接受分页传参的情况：数据大于旧的 行 数量
    if (turnOnScroll === false && backData?.length > sizeStr && sizeStr) {
      backData.splice(this.pageSize)
    }
    // 需要将当前数据保存在共享数据池中，使用当前组件的myid作为键
    this.context.shareDataPool.setData(
      `layoutData-${this.ids.container_id}-${this.ids.rect_id}-${this.activeIndex}`,
      JSON.stringify(backData)
    )
    // 开启了自动滚动，但是返回条数小于单元格数，需要用重复数据填充
    if (turnOnScroll && backData?.length && Math.max(oldRowsLength, oldColsLength) > (backData?.length || 0)) {
      const base = Math.ceil(Math.max(oldRowsLength, oldColsLength) / backData.length)
      const temp = simpleDeepClone(backData)
      for (let i = 1; i < base; i++) {
        backData = backData.concat(simpleDeepClone(temp))
      }
      this.totalRecords = backData.length
    }
     // 将当前分类数据保存起来
     const classifyData = this.setClassifyData(this.wholeDataTypes[this.activeIndex])
     this.context.shareDataPool.setData(
       `layoutRestClassify-${this.ids.container_id}-${this.ids.rect_id}-${this.ids.elementInAutoLayoutId}-${this.ids.path}`,
       JSON.stringify(classifyData)
     )
     // 分类数据改变 发出通知
     this.context.$eventBus.$emit(
       `layout-classify-update-eventBus-${this.ids.container_id}-${this.ids.rect_id}-${this.ids.elementInAutoLayoutId}-${this.ids.path}`,
       {
         data: classifyData
       }
     )
    if (backData?.length) {
      if (typeof this.updateEleCb === "function")
        this.updateEleCb(false, "emptyData", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          pageId: this.ids.pageId
        })
      return this.drawData(backData)
    } else {
      console.log("接口数据为空")
      if (typeof this.updateEleCb === "function") {
        this.updateEleCb(true, "emptyData", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          pageId: this.ids.pageId
        })
      }
      return { completeData: [] }
    }
  }
  // 组装分类数据
  setClassifyData(datas) {
    let list = []
    if (datas) {
      Object.keys(datas).forEach((key, index) => {
        if (key === "viewNum" || key === "name" || key === "time" || key === "iconUrl" || key === "topUrl" || key === "introduction") {
          let str = {}
          str.value = key
          str.content = "" + datas[key]
          if (key === "viewNum") str.label = "浏览量"
          if (key === "name") str.label = "分类名称"
          if (key === "time") str.label = "分类发布时间"
          if (key === "iconUrl") str.label = "分类图标"
          if (key === "topUrl") str.label = "分类广告图"
          if (key === "introduction") str.label = "简介"
          list.push(str)
        }
      })
      return list
    }
    return []
  }
  // 是否是否包含有插件的表格组件
  isContainPluginTable(colsIdFromActiveRect) {
    const useActiveIndex = this.rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.activeIndex
    const pOptions = [this.rectAttr.options.rows[useActiveIndex]]
    let result = false
    for (let i = 0; i < colsIdFromActiveRect.length; i++) {
      let uid = colsIdFromActiveRect[i]
      const elementInLayoutOptions = this.checkUpdateType(pOptions, uid)
      if (elementInLayoutOptions) {
        result = elementInLayoutOptions.some(ele => ele.pluginName?.includes("getParentEngineDataPlugin"))
      }
      if (result) break
    }
    return result
  }

  /**
   * @param {*} listPageId
   * 由于有些样式不存在更多组件，所以用try catch
   */
  initMoreData(listPageId) {
    // 找到当前自由布局组件中更多组件的位置
    const { pageId } = this.context.$store.state.states.getDataPageIds
    try {
      const { directionIndex, elementInLayoutId } = findTabs(this.rectAttr, null, "more")
      let previewLink
      if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
        previewLink = `//mh.chaoxing.com/mhssr/?p=${listPageId}&hp=${pageId}`
      } else {
        previewLink = `/v2/sub/${listPageId}/0/0/0/${pageId}`
      }
      if (!!previewLink) {
        let param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          pageId: this.ids.pageId,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "linkUrl",
          option_val: previewLink
        }
        this.context.$store.dispatch(this.context.request_prefix + "/changeTitleOptions", param)
      }
    } catch (error) {}
  }
  async getAppointData(pageSize) {
    let typeId = undefined
    let url
    if (this.typeId) {
      // 如果从外面传入了typeId，说明是列表页的多级分类组件传入的，否则就是首页的tab导航组件传入
      typeId = this.typeId
      url = replaceUrlParam(this.restDataUrl, "t", typeId ? typeId : "")
    } else if (this.typeIds?.length) {
      /*多级筛选选择*/
      url = replaceUrlParam(this.restDataUrl, "isOr", this.isOr) + "&typeIds=" + this.typeIds + "&relIds" + this.relIds
    } else if (this.dateVal?.length) {
      /*日历联动选择*/
      url = replaceUrlParam(this.restDataUrl, "date", this.dateVal)
    } else {
      let twoTabsLayout = false
      if (this.rectAttr.options.pluginName?.includes("fetch-twoTabsLayoutPlugin")) twoTabsLayout = true
      if (this.cacheDataTypes.length) {
        //对于有类型的数据进行分类请求
        if (twoTabsLayout) {
          typeId = this.cacheDataTypes[this.activeIndex - 1]
        } else {
          typeId = this.cacheDataTypes[this.activeIndex]
        }
      }
      if (twoTabsLayout && this.activeIndex === 0) {
        let url = "mhadapter/universal-cors/85923f4f34b74469a443512fd662ac11"
        let results = []
        let totalRecords = 0
        await this.context.instance
          .get(`app/data-source/my-apps?page=${this.pageNum}&pageSize=${this.pageSize}`)
          .then(res => {
            if (res?.data?.code === 1) {
              results = res?.data?.data?.results
              totalRecords = res?.data?.data?.totalRecords
            }
          })
        let dataList = []
        let addItem = {
          0: {
            pageType: 1,
            value: "https://p.ananas.chaoxing.com/star3/origin/97a92b47a57b5f563cb2ae611d6bc807.jpg",
            key: "封面",
            url: ""
          },
          1: {
            pageType: 1,
            value: "添加常用",
            key: "标题",
            url: ""
          }
        }
        // 处理数据源拿回来的数据
        results?.forEach(item => {
          let dataItem = {}
          item.fields.forEach(field => {
            dataItem[field.flag] = field
          })
          dataList.push(dataItem)
        })
        dataList.push(addItem)
        // 模拟'我的常用'分类下的数据
        return {
          data: {
            data: {
              datas: {
                datas: dataList,
                totalRecords: totalRecords + 1
              }
            }
          }
        }
      } else {
        url = this.restDataUrl ? replaceUrlParam(this.restDataUrl, "t", typeId ? typeId.publicId : "") : ""
      }
    }
    let params = ""
    if(this.dataCenterContent?.params) {
      const dataParams = parseQueryString(this.dataCenterContent.params)
      let express = dataParams.express
      const arr = []
      if(express && Array.isArray(express)) {
        this.context.options && (this.context.options.express = express)
        express.forEach(item => {
          if (item.valueType === "CURR_PAGE_FIELD") {
            // 链接参数
            if (item.val === "999999" && item.linkVal && getQueryParam(item.linkVal)) {
              arr.push({
                id: item.linkVal,
                val: getQueryParam(item.linkVal)
              })
            }
          }
        })
        if (arr.length > 0) {
          params = JSON.stringify(arr)
        }
      }
    }
    let dataUrl = `${url + getSwData(this.rectAttr.options)}&p2=${pageSize}&p=${this.pageNum}`
    if (params) {
      dataUrl += `&params=${encodeURIComponent(params)}`
    }

    return this.context.asyncTask.add(this.context.instance.get(dataUrl))
  }
  // 当外部传入了typeId时，获取面包屑数据
  async getBreadCrumbsData() {
    return this.context.$API.queryCrumbData({
      typeId: this.typeId
    })
  }
  drawData(result) {
    const useActiveIndex = this.rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.activeIndex
    const pOptions = [this.rectAttr.options.rows[useActiveIndex]]
    const completeData = this.getDataInfo(result)
    let drawLayoutAlready = false
    let elementInlayout = null
    let nowUidHadElement = false
    if (typeof this.ids.uid === "string" && this.ids.uid.length) {
      //如果当前选中的这个col有elementinlayout，那就把当前这个col内部的组件作为模板
      let _elementInlayout = handleFindLayoutComponentOptions(pOptions, this.ids.uid)
      if (typeof _elementInlayout !== "undefined" && _elementInlayout.length > 0) {
        nowUidHadElement = true
        drawLayoutAlready = {
          uid: this.ids.uid,
          elementInlayout: _elementInlayout
        }
      }
    }
    if (!nowUidHadElement) {
      //否则就开始循环当前布局组件中的col
      //循环判断遍历出的最底层cols中是否为空（列中没有组件）
      /* 加了自由布局滚动后请求的是所有数据，关闭滚动功能需要还原所有数据 */

      // 如果没有布局类型，先修改的列，视为列布局，否则为行布局
      const [layoutType] = findHistoryLayoutType(pOptions[0])
      const { oldRowsLength, oldColsLength, turnOnScroll } = this.rectAttr.options
      let oldWidthOrHeight = Math.max(oldRowsLength, oldColsLength) || result.length
      if (turnOnScroll) {
        if (this.colsIdFromActiveRect.length < result.length) {
          // 自由布局的行数小于返回的数据数量
          // 需要先补齐单元格，计算缩放比例
          const newLen = result.length
          const addLen = result.length - this.colsIdFromActiveRect.length
          this.editNewRowAndCol(layoutType, newLen, addLen, true)
          this.context.$changeOptionsEV(
            Number((newLen / oldWidthOrHeight).toFixed(2)),
            "scrollMultiple",
            false,
            null,
            this.ids,
            true
          )
          this.colsIdFromActiveRect = this.getColsIdFromActiveRect()
        } else if (this.colsIdFromActiveRect.length > result.length) {
          // 自由布局的行数大于返回的数据数量
          // 需要先删除单元格，计算缩放比例
          const newLen = result.length
          const minusLen = this.colsIdFromActiveRect.length - result.length
          this.editNewRowAndCol(layoutType, newLen, -minusLen, false)
          this.context.$changeOptionsEV(
            Number((newLen / oldWidthOrHeight).toFixed(2)),
            "scrollMultiple",
            false,
            null,
            this.ids,
            true
          )
          this.colsIdFromActiveRect = this.getColsIdFromActiveRect()
        } else {
          // 这里判断所有的行、列都是自由布局自己的，而不是自动滚动加上的
          if (this.colsIdFromActiveRect.length === oldWidthOrHeight) {
            this.context.$changeOptionsEV(1, "scrollMultiple", false, null, this.ids, true)
          } else {
            this.context.$changeOptionsEV(
              Number((this.colsIdFromActiveRect.length / oldWidthOrHeight).toFixed(2)),
              "scrollMultiple",
              false,
              null,
              this.ids,
              true
            )
          }
        }
      } else if (turnOnScroll === false && this.colsIdFromActiveRect.length > oldWidthOrHeight && (oldRowsLength === 1 || oldColsLength === 1)) {
        // 关闭滚动，删除当前多余的数据行
        this.editNewRowAndCol(
          layoutType,
          oldWidthOrHeight,
          -(this.colsIdFromActiveRect.length - oldWidthOrHeight),
          false
        )
      }
      // 需要将当前数据保存在共享数据池中，使用当前组件的myid作为键
      this.context.shareDataPool.setData(
        `layoutData-${this.ids.container_id}-${this.ids.rect_id}-${this.activeIndex}-uids`,
        JSON.stringify(this.colsIdFromActiveRect)
      )
      for (let i = 0; i < this.colsIdFromActiveRect.length; i++) {
        let tempUid = this.colsIdFromActiveRect[i]
        elementInlayout = handleFindLayoutComponentOptions(pOptions, tempUid)
        if (typeof elementInlayout !== "undefined" && elementInlayout.length > 0) {
          //一开始进来找到的第一个col就是模板col
          if (!drawLayoutAlready) {
            drawLayoutAlready = {
              uid: tempUid,
              elementInlayout
            }
            //如果一开始找到这个模板col的字段数量和字段类型和后台数据一致 就不用往下找了
            if (this.checkMsgStatus(completeData, elementInlayout)) break
          } else if (this.checkMsgStatus(completeData, elementInlayout)) {
            drawLayoutAlready = {
              uid: tempUid,
              elementInlayout: elementInlayout
            }
            break
          }
        }
      }
    }
    this.context.$eventBus.$emit(`update-layout-data-eventBus-${this.ids.container_id}-${this.ids.rect_id}`, {
      layoutSrollUpdateFlag: true
    })
    return { completeData, drawLayoutAlready }
  }
  // 编辑新的行列
  editNewRowAndCol(layoutType, newLen, addLen, copyStyle) {
    // 判断行、列是增加还是删减，然后操作
    // 如果没有布局类型，先修改的列，视为列布局，否则为行布局
    // 注意：因为滚动的都是单行或者单列，所以注意layoutType
    if (layoutType === "col") {
      if (addLen !== 0) {
        if (addLen > 0) {
          this.context.$store.dispatch(this.context.request_prefix + "/updateRowLenInLayout", {
            ...this.ids,
            type: "add",
            rowsLen: +newLen,
            colsLen: 1,
            addLen: Math.abs(addLen),
            layoutType: "row",
            editType: "layout"
          })
        } else {
          this.context.$store.dispatch(this.context.request_prefix + "/updateRowLenInLayout", {
            ...this.ids,
            type: "sub",
            rowsLen: +newLen,
            colsLen: 1,
            subLen: Math.abs(addLen),
            moveLastLeaf: +newLen === 1,
            editType: "layout"
          })
        }
      }
    } else {
      if (addLen !== 0) {
        if (addLen > 0) {
          this.context.$store.dispatch(this.context.request_prefix + "/updateColLenInLayout", {
            ...this.ids,
            type: "add",
            rowsLen: 1,
            colsLen: +newLen,
            addLen: Math.abs(addLen),
            layoutType: "col",
            editType: "layout"
          })
        } else {
          this.context.$store.dispatch(this.context.request_prefix + "/updateColLenInLayout", {
            ...this.ids,
            type: "sub",
            rowsLen: 1,
            colsLen: +newLen,
            subLen: Math.abs(addLen),
            moveLastLeaf: +newLen === 1,
            editType: "layout"
          })
        }
      }
    }
    if (copyStyle) {
      this.copyLayoutStyle()
    }
  }
  // 复制单元格样式
  copyLayoutStyle() {
    const addUids = JSON.parse(sessionStorage.getItem("addUids") || "[]")
    const colUids = []
    const useActiveIndex = this.rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.rectAttr.options.activeIndex
    let topRows = this.rectAttr.options.rows[useActiveIndex].cols[0].rows
    handleFindLayoutComponentAllUid(topRows, colUids)
    // 获取基准值，用于复制样式的参照物，遍历叶子节点，第一个就是基准值
    const reference = colUids[0]
    const _rectAttr = getRectAttribute.call(this.context, this.ids)
    const _useActiveIndex = _rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : _rectAttr.options.activeIndex
    const pOptions = [_rectAttr.options.rows[_useActiveIndex]]
    for (let i = 0; i < addUids.length; i++) {
      const baseId = { container_id: this.ids.container_id, rect_id: this.ids.rect_id, pageId: this.ids.pageId }
      const result = {
        ...baseId,
        baseUid: reference,
        content: simpleDeepClone(handleFindLayoutComponentOptionsCols(pOptions, reference)),
        uid: addUids[i]
      }
      this.context.$event.mergeEvent(
        {
          from: { ...baseId, uid: reference },
          to: { ...baseId, uid: addUids[i] }
        },
        "col"
      )
      this.context.$store.dispatch(this.context.request_prefix + "/changeLayoutComponentBoxOption", result)
    }
    sessionStorage.removeItem("addUids")
  }
  checkMsgStatus(completeData, elementInLayout) {
    if (!completeData || !completeData[0]) return false
    let [imgDataLen, textDataLen, eleTextDataLen, eleImgDataLen] = [0, 0, 0, 0]
    completeData[0] &&
      Object.keys(completeData[0]).length &&
      Object.keys(completeData[0]).forEach(key => {
        completeData[0][key]?.component_shape === "imageComponent" ? imgDataLen++ : textDataLen++
      })
    elementInLayout.forEach(item => {
      item.innerElement === "imageComponent" ? eleImgDataLen++ : eleTextDataLen++
    })
    return imgDataLen === eleImgDataLen && textDataLen === eleTextDataLen
  }
  //过滤掉数据中没用的数据和空数据，并给每个数组元素判断出需要增加的组件类型
  getDataInfo(result) {
    const _result = JSON.parse(JSON.stringify(result))
    Object.keys(_result).forEach(key => {
      Object.keys(_result[key]).forEach(dataItemKey => {
        // 保留url和publicId
        if (dataItemKey === "url") return
        if (dataItemKey === "publicId") return
        if (dataItemKey === "id") return
        if (dataItemKey === "pageType") return
        if (dataItemKey === "viewNum") return
        if (isNaN(dataItemKey)) {
          delete _result[key][dataItemKey]
        } else {
          if (isFieldAllEmpty(_result, dataItemKey)) {
            delete _result[key][dataItemKey]
          } else {
            const componentShape = fixComponent(dataItemKey, _result[key][dataItemKey].value)
            _result[key][dataItemKey].component_shape = componentShape
          }
        }
      })
    })
    return _result
  }
  //开始生成自由布局组件前的检查检查完毕
  // -----------------------------------------------
  // =====================================
  startUpdateLayout(completeData, drawLayoutAlready, menus) {
    if (!completeData) {
      return
    }
    this.menus = menus
    const rectIds = {
      container_id: this.ids.container_id,
      rect_id: this.ids.rect_id,
      pageId: this.ids.pageId
    }
    const useActiveIndex = this.rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.activeIndex
    const pOptions = [this.rectAttr.options.rows[useActiveIndex]]
    const notEmptyColsFromRect = [] //有组件的col的uid
    const emptyColsIdFromActiveRect = [] //没组件的col的uid
    const colsIdFromActiveRect = this.getColsIdFromActiveRect()
    this.colsIdFromActiveRect = colsIdFromActiveRect
    this.colsIdFromActiveRect.forEach(uid => {
      if (handleFindLayoutComponentOptions(pOptions, uid)?.length) {
        notEmptyColsFromRect.push(uid)
      } else {
        emptyColsIdFromActiveRect.push(uid)
      }
    })
    let status = true
    let fieldMappingList = this.getFiledMappingList(completeData)
    for (let i = 0; i < notEmptyColsFromRect.length; i++) {
      const uid = notEmptyColsFromRect[i]
      const elementInLayoutOptions = this.checkUpdateType(pOptions, uid)
      const tempData = completeData[i]
      let param = Object.assign({ uid }, rectIds)
      if (tempData) {
        //如果有组件就要走更新流程
        const hasDataK = elementInLayoutOptions.some(
          ele => ele.filedMapping && ele.filedMapping.hasOwnProperty("value") && ele.filedMapping.value !== null
        )
        this.componentBoxUpdateCb({
          url: tempData.url,
          pageType: tempData.pageType,
          dataId: tempData.publicId ? tempData.publicId : tempData.id,
          uid
        })
        if (hasDataK) {
          //如果col中的组件中有字段映射关系就走新逻辑，col中的全部组件都没字段映射关系就走老逻辑
          elementInLayoutOptions.forEach(ele => {
            const dataK = ele?.filedMapping?.value
            const isDate = ele?.filedMapping?.isDate
            const dateStyle = ele?.filedMapping?.dateStyle
            const dateTitle = ele?.filedMapping?.dateTitle
            const dataType = ele?.filedMapping?.dataType
            if (dataK !== null && !isNaN(dataK) && tempData.hasOwnProperty(dataK)) {
              let tempDataValue = tempData[dataK].value
              // 如果有dataType 判断获取格式
              if (dataType === "dataKey") {
                tempDataValue = tempData[dataK].key + "：" + tempData[dataK].value
              } else if (dataType === "dataName") {
                tempDataValue = tempData[dataK].key
              }
              //如果有dataKey 说明有字段映射关系 就优先去那对应映射关系的数据
              param.elementInLayoutId = ele.elementInLayoutId
              // 增加日期格式判断，如果是日期字段，需要走日期格式化方法
              // 如果是视频 增加支持云盘判断
              param.option_val =  ele.videoObjectId
                ? tempData[dataK].objectId
                : isDate
                ? formatterDateHandle(tempData[dataK].value, dateStyle, dateTitle, tempData[dataK].key)
                :tempDataValue
              param.option_name = this.fixOptName([ele.innerElement])
              if (ele.innerElement === "cxVideo") {// 处理视频 如果返回的value是图片格式就渲染成图片 取url
                if (tempData[dataK].value && isImage(tempData[dataK].value)) {
                  param.option_name = "videoImageUrl"
                  param.option_val = tempData[dataK].url
                } else if (ele.videoImageUrl) {// 如果有图片需要清空
                  this.updateCb({
                    ...JSON.parse(JSON.stringify(param)),
                    option_name: "videoImageUrl",
                    option_val: ""
                  }, ele.opacity)
                }
              }
              this.updateCb(param, ele.opacity)
            } else {
              // 未绑定字段匹配 不能隐藏组件 显示原本的值
              param.elementInLayoutId = ele.elementInLayoutId
              param.option_name = this.fixOptName([ele.innerElement])
              this.showComponentCb(param, ele.opacity)
            }
            // 绑定了字段匹配 但是为空 隐藏组件
            if (dataK !== null && !isNaN(dataK) && !tempData.hasOwnProperty(dataK)) {
              param.elementInLayoutId = ele.elementInLayoutId
              param.option_val = ""
              param.option_name = this.fixOptName([ele.innerElement])
              this.updateCb(param, ele.opacity)
              this.hideComponentCb(param)
            }
          })
        } else {
          // col中的组件都没有字段映射 走老逻辑
          elementInLayoutOptions.forEach(ele => {
            const dataK = Object.keys(tempData).find(k => {
              let res
              try {
                res = tempData[k].component_shape && tempData[k].component_shape.find(it => it === ele.innerElement)
              } catch (error) {
                console.log("error", k, tempData[k])
                console.log(error)
              } finally {
                return res
              }
            })
            // 让文本列表页的icon重新显示出来
            if (ele.innerElement === "cxIcon") {
              param.elementInLayoutId = ele.elementInLayoutId
              param.option_name = this.fixOptName([ele.innerElement])
              this.updateCb(param, ele.opacity)
            }
            if (dataK !== undefined && tempData.hasOwnProperty(dataK)) {
              param.elementInLayoutId = ele.elementInLayoutId
              param.option_val = tempData[dataK].value
              param.option_name = this.fixOptName([ele.innerElement])
              this.updateCb(param, ele.opacity)
              //老逻辑中 被用了的数据需要删除
              delete tempData[dataK]
            } else if (
              // 仅有这些可以参与数据渲染的组件才需要隐藏
              ele.innerElement === "imageComponent" ||
              ele.innerElement === "cxText" ||
              ele.innerElement === "cxButton" ||
              ele.innerElement === "cxEditor" ||
              ele.innerElement === "cxLabel"
            ) {
              param.elementInLayoutId = ele.elementInLayoutId
              // 没有绑定字段匹配 不用隐藏 正常显示
              param.elementInLayoutId = ele.elementInLayoutId
              param.option_name = this.fixOptName([ele.innerElement])
              this.showComponentCb(param, ele.opacity)
            }
          })
        }
        this.componentBoxUpdateOpacity({
          opacity: 100,
          uid: param.uid
        })
        //   文本组件预存预警字段，用于后面选择
        elementInLayoutOptions.forEach(ele => {
          if(ele.innerElement === "cxText"){
            if (typeof this.updateEleCb === "function"){
              this.updateEleCb(fieldMappingList, "warningFieldMappingList", false, null, {
                rect_id: this.ids.rect_id,
                container_id: this.ids.container_id,
                uid: uid,
                elementInLayoutId: ele.elementInLayoutId,
                pageId: this.ids.pageId,
              })
            }
          }
        })
      } else {
        //如果没有数据了 就不执行更新和后续的生成逻辑，把剩余的cols内的组件清空
        status = false
        elementInLayoutOptions.forEach(ele => {
          if (ele.filedMapping?.value !== "tabs" || this.rectAttr.options.openHideEmptyCell !== false) {
            // 注入逻辑，如果该组件的字段映射的分类，不删除
            this.delElementCb(Object.assign({ elementInLayoutId: ele.elementInLayoutId }, param), ele.opacity)
          }
          if (this.rectAttr.options.openHideEmptyCell === false) {
            this.showComponentCb(Object.assign({ elementInLayoutId: ele.elementInLayoutId }, param), ele.opacity)
          }
        })
        // 空数据单元格隐藏增加按钮控制
        if (this.rectAttr.options.openHideEmptyCell === false) {
          this.componentBoxUpdateOpacity({
            opacity: 100,
            uid: param.uid
          })
        } else {
          this.componentBoxUpdateOpacity({
            opacity: 0,
            uid: param.uid
          })
        }
      }
    }
    if (status && completeData?.length !== notEmptyColsFromRect.length) {
      //如果有数据的话 其他的空的cols的更新方式和createLayoutComponent函数的更新方式一致
      let _elementInLayout = drawLayoutAlready ? JSON.parse(JSON.stringify(drawLayoutAlready.elementInlayout)) : false
      this.createLayoutComponent(
        completeData.slice(notEmptyColsFromRect.length),
        emptyColsIdFromActiveRect,
        _elementInLayout
      )
    }
  }

  getColsIdFromActiveRect() {
    let { renderOrder, rows, categoryMode } = this.rectAttr.options
    // 旧数据格式不同的清除重做
    if (Array.isArray(renderOrder)) {
      renderOrder = {}
    }
    const useActiveIndex = categoryMode === CATEGORY_MODE.SAME ? 0 : this.activeIndex
    const defaultOrder = getDefaultColsUidInLayoutComponent([rows[useActiveIndex]])
    let colsIdFromActiveRect = []
    if (renderOrder?.[this.activeIndex]?.length) {
      const curOrder = renderOrder[this.activeIndex]
      // 这里需要处理脏数据
      if ([...curOrder].sort().join("|") === [...defaultOrder].sort().join("|")) {
        colsIdFromActiveRect = renderOrder[this.activeIndex]
      } else {
        colsIdFromActiveRect = defaultOrder
        const newRenderOrder = Object.assign(renderOrder || {}, { [this.activeIndex]: [] })
        this.context.$changeOptionsEV(newRenderOrder, "renderOrder", null, false, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
      }
    } else {
      colsIdFromActiveRect = defaultOrder
    }
    if (this.rectAttr.options.reverseGetColsUid) {
      colsIdFromActiveRect.reverse()
    }
    return colsIdFromActiveRect
  }

  //开始进行组件生成
  createLayoutComponent(complete, colsIdFromActiveRect, _elementInLayout, menus) {
    this.menus = this.menus ? this.menus : menus
    const _colsIdFromActiveRect = colsIdFromActiveRect ? colsIdFromActiveRect : this.colsIdFromActiveRect
    const _completeData = complete

    const componentShapes = [] // ['imageComponent', 'cxText', 'swiperComponent']
    //遍历出单条所选数据的组件类型
    _completeData &&
      _completeData[0] &&
      Object.keys(_completeData[0]).length >= 1 &&
      Object.keys(_completeData[0]).forEach(complateDataKey => {
        !isNaN(complateDataKey) && componentShapes.push(_completeData[0][complateDataKey].component_shape)
      })
    for (let i = 0; i < _colsIdFromActiveRect.length; i++) {
      //如果数据数量小于表格数量就退出循环
      if (i === _completeData.length) {
        break
      }
      const rectIds = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        pageId: this.ids.pageId
      }
      const tempData = _completeData[i]
      this.componentBoxUpdateCb({
        url: tempData.url,
        dataId: tempData.publicId ? tempData.publicId : tempData.id,
        uid: _colsIdFromActiveRect[i]
      })
      if (_elementInLayout && _elementInLayout.length) {
        const hasDataK = _elementInLayout.some(
          ele => ele.filedMapping && ele.filedMapping.hasOwnProperty("value") && ele.filedMapping.value !== null
        )
        if (hasDataK) {
          //如果col中的组件中有字段映射关系就走新逻辑，col中的全部组件都没字段映射关系就走老逻辑
          _elementInLayout.forEach(ele => {
            const dataK = ele?.filedMapping?.value
            if (dataK !== null && !isNaN(dataK)) {
              //如果有dataKey 说明有字段映射关系 就优先去那对应映射关系的数据
              this.addCb(
                Object.assign(
                  { uid: _colsIdFromActiveRect[i], elementOptions: this.fixCreateEleByTemplate(ele, tempData) },
                  rectIds
                )
              )
            }
          })
        } else {
          //  如果有模板 就用模板来进行渲染
          _elementInLayout.forEach(ele => {
            const param = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              pageId: this.ids.pageId,
              uid: _colsIdFromActiveRect[i],
              elementOptions: this.fixCreateEleByTemplate(ele, tempData)
            }
            this.addCb(param)
          })
        }
      } else {
        //没有模板 生成全量
        let totalHeight = 0
        componentShapes.forEach((itemShapeName, itemShapeIndex) => {
          //如果当前组件内有已经写好的模板列，那么就依照当前模板列的样式来进行绘制，否则就从menu中获取
          let _attribute = this.menus.find(item => itemShapeName.find(it => it === item.type))
          if (_attribute) {
            //根据组件类型不同，修改对应组件的value，如图片组件的value是imagesrc，文字组件的value是text等。
            _attribute = this.fixCreateEle(_attribute, _completeData, i, itemShapeName, itemShapeIndex)
            _attribute.top = totalHeight
            totalHeight += _attribute.height
            const param = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              pageId: this.ids.pageId,
              uid: _colsIdFromActiveRect[i],
              activeIndex: this.activeIndex,
              elementOptions: _attribute
            }
            // 没有组件时不渲染
            this.addCb(param)
          }
        })
      }
    }
  }
  fixCreateEleByTemplate(ele, data) {
    const shape = ele.innerElement
    const hasK = ele?.filedMapping?.value
    if (hasK !== null && !isNaN(hasK) && data[hasK]) {
      ele[this.fixOptName([shape])] = data[hasK].value
    } else {
      const newValK = Object.keys(data).find(k => data[k].component_shape.find(it => it === shape))
      ele[this.fixOptName([shape])] = data[newValK].value
      delete data[newValK]
    }
    return ele
  }
  fixCreateEle(_attribute, _complateData, itemKey, shapeName, itemShapeIndex) {
    let origin = JSON.parse(JSON.stringify(_attribute))
    if (origin.children) {
      origin = origin.children[0].attribute.options
    }
    let dataItem = null
    try {
      Object.keys(_complateData[itemKey]).forEach((item, index) => {
        if (index === itemShapeIndex) {
          dataItem = _complateData[itemKey][item]
        }
      })
    } catch (error) {
      console.log(arguments)
    }
    origin[this.fixOptName(shapeName)] = dataItem.value
    return origin
  }
  getDataValue(_complateData, itemKey, itemShapeIndex) {
    let dataItemVal = null
    Object.keys(_complateData[itemKey]).some(key => {
      if (_complateData[itemKey][key].component_shape === itemShapeIndex) {
        dataItemVal = _complateData[itemKey][key].value
        delete _complateData[itemKey][key]
        return true
      }
    })
    return dataItemVal
  }

  //区分不同组件的option_name不一致的问题
  fixOptName(shape) {
    if (
      shape.find(
        it => it === "cxText" || it === "cxDigitRoll" || it === "cxButton" || it === "cxEditor" || it === "cxLabel"
      )
    ) {
      return "content"
    } else if (shape.find(it => it === "cxVideo")) {
      return "videoUrl"
    } else if (shape.find(it => it === "cxAudio")) {
      return "audioUrl"
    } else if (shape.find(it => it === "cxCode")) {
      return "linkUrlVal"
    } else if (shape.find(it => it === "cxIframe")) {
      return "iframeUrl"
    } else {
      return "imgSrc"
    }
  }
  checkUpdateType(pOptions, uid) {
    let elementInlayout = handleFindLayoutComponentOptions(pOptions, uid)
    if (typeof elementInlayout !== "undefined" && elementInlayout.length > 0) {
      //cols中已经有布局了,且里面的组件数量与数据数量一致
      return elementInlayout
    }
    //没有布局
    return false
  }

  getFiledMappingList(datas) {
    let list = []
    if(datas[0]){
      Object.keys(datas).forEach((key, index) => {
        if (key === "content") return
        if (key && datas[0][key]?.value) {
          const temp = {
            value: key,
            label: datas[0][key].key,
            content: datas[0][key].value
          }
          list.push(temp)
        }
      })
    }
    return list
  }
}
